/* eslint-disable import/no-anonymous-default-export */
export default {
    mainRoute: 'https://www.facebook.com/BluSageSalon/',
    navLinks: {
    }
}
